import React, { useEffect, useState } from 'react';
import { Box, FormControl, InputLabel, Link, MenuItem, Select, Typography, Button, Checkbox } from '@mui/material';
import { Formik, Field, Form } from 'formik';
import arrowleft from '../../../src/assests/images/arrow-red.svg';
import * as Yup from 'yup';
import { styled } from '@mui/material/styles';
import { teamform, getmodules, getteamlist, approverequest, getTeamById, pauseaccount, moduleowner, getmodulesowner } from './api';
import { decodeJWT, getToken } from "../../utils/utils";
// import { useRouter } from 'next/router';
import { useAlert } from "../../pages/AlertContext/AlertContext";
import { useNavigate, useParams } from 'react-router-dom';
import ConfirmPopup from './ConfirmPopup';
import { values } from 'lodash';


const LineArrow = () => (
    <svg
        width="14"
        height="8"
        viewBox="0 0 14 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M1 1L7 7L13 1" stroke="#000" strokeWidth="1.5" />
    </svg>
);
const token = getToken();

interface FormValues {

    id: string; // Add id property here
    first_name: string;
    last_name: string;
    mobile_num: string;
    company_email_id: string;
    team_id: string;
    module_id: string[];

    module_owner_email: string;
    login_password: string;
}
interface Module {
  id: number | string;
  module_name: string;

}

const ModuleOwnerForm = () => {
    // const team = ['All Team', 'PMI Internal', 'Lollypop Team',];
    // const dash = ['Dashboard, Reports', 'PMI Internal', 'Lollypop Team',];
    const [team, setteam] = useState([]);
    const [generatedPassword, setGeneratedPassword] = useState('');
      const [statusdata, setstatusdata] = useState(false);
  const [modules, setModules] = useState<Module[]>([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
    const [modulenamoopup, setmodulenamoopup] = useState('');
 const [emaailvalues, setemaailvalues] = useState('');
    
const [selectedModuleNames, setSelectedModuleNames] = useState<string>("");
const [firstnme,serFirstnames]= useState<string>("");

   const handleOpenConfirm = () => {
    setConfirmOpen(true);
  };

  const handleCloseConfirm = () => {
    setConfirmOpen(false);
  };

  const handleConfirmSubmit = () => {
    // perform form submit action here
    console.log('Form submitted!');
    setConfirmOpen(false);
  };



    const { id } = useParams();
    const navigate = useNavigate();
    const { showAlert } = useAlert();
    const [initialValues, setInitialValues] = useState<FormValues>({
        id: '',
        first_name: '',
        last_name: '',
        mobile_num: '',
        company_email_id: '',
        team_id: '',
        module_id: [],
        // module_owner: '',
        module_owner_email: '',
        login_password: '',
    });

    useEffect(() => {
        const newPassword = generatePassword();
        setGeneratedPassword(newPassword);
    }, []);


    useEffect(() => {
        const fetchModules = async () => {
            try {
                const res = await getmodulesowner(token);
                setModules(res?.data?.data || []);

            } catch (error) {
                console.error('Failed to fetch modules:', error);
                setModules([]); // fallback in case of error
            }
        };

        fetchModules();
    }, []);

    useEffect(() => {
        const fetchTeamData = async () => {
            try {
                const res = await getteamlist(token); // Replace with your API endpoint
                setteam(res?.data?.data || []);; // Assuming the data is in the 'data' field

            } catch (error) {
                console.error("Error fetching team data:", error);
            }
        };

        fetchTeamData();
    }, []);
    const generatePassword = (length = 10) => {
        const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$!';
        let password = '';
        for (let i = 0; i < length; i++) {
            password += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return password;
    };
    
    const handleSubmit = async (values: {
        first_name: string; last_name: string; mobile_num: string; company_email_id: string; team_id: string; module_id: string[]; module_owner_email
        : string; login_password: string;
    }) => {
        try {
            // Sending form data to the teamform API
            const response = await moduleowner(values, token);
console.log(response.data.success , "response.data.success ssssss")
              if (response.data.success === true) {
       
                showAlert("Module Owner successfully Saved!", "success");
                navigate(`/team-Members`);
        setTimeout(() => window.location.reload(), 100);
            }else{
                  showAlert('Module owner with this email already exists.');
            }
            // Handle success, you can redirect or show success message here
            console.log('Form Submitted Successfully:', response);
        } catch (error: any) {
    console.error("Error submitting the form:", error);

    // Check if backend returned a structured error
    const errorMessage =
      error?.response?.data?.error || "Something went wrong. Please try again.";

    showAlert(errorMessage, "error");
  }
};
const handleYes = () => {
 
};
    //  const handleApprove = async (id: string, is_approved: string | undefined) => {
    //     try {
    //                 const numericId = Number(id);
    //         if (id && is_approved !== undefined) {
    //             const response = await approverequest(numericId, { is_approved }, token);
    //             console.log('Approval Response:', response);
    //             if (response?.data?.success) {
    //                 alert('Team member approval status updated successfully!');
    //             } else {
    //                 alert('Failed to update approval status.');
    //             }
    //         } else {
    //             alert('ID or approval status is missing.');
    //         }
    //     } catch (error) {
    //         console.error('Error during approval:', error);
    //         alert('There was an issue with the approval request.');
    //     }
    // };
    useEffect(() => {
        const fetchTeamData = async () => {
            if (!id) return;

            try {
                const res = await getTeamById(id as string, token);
                const data = res.data.data;

                setInitialValues({
                    id: data.id || '',
                    first_name: data.first_name || '',
                    last_name: data.last_name || '',
                    mobile_num: data.mobile_num || '',
                    company_email_id: data.company_email_id || '',
                    team_id: Array.isArray(data.team_id) ? data.team_id : [],
                    module_id: Array.isArray(data.module_id) ? data.module_id : [],
                    module_owner_email: data.module_owner_email || '',
                    login_password: data.login_password || '',
                });
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchTeamData();
    }, [id]);

console.log(selectedModuleNames, "selectedModuleNames778888888888")

 const decodedToken = decodeJWT(token);
    console.log(decodedToken, "decodedTokendecodedTokendecodedToken",token, "tokentokentokentoken")
    const mainemaill = decodedToken?.email || "guest";
console.log(emaailvalues, "mainemaillmainemaillmainemaill");
    return (
        <Box>
            <Box sx={{ backgroundColor: "#F9FBFC", padding: "32px 32px 0" }}>
                <Box sx={{ borderBottom: "1px solid #E7E8E9", paddingBottom: "20px" }}>
                    <Link
                        href="#"
                        sx={{
                            textDecoration: "none",
                            fontSize: 14,
                            fontWeight: 600,
                            color: "rgba(142, 2, 15, 1)",
                            display: "flex",
                        }}
                    >
                        {/* <Typography sx={{ color: "#696A6B", marginRight: "10px" }}>
                            Team Member /
                        </Typography>{" "}
                        Add Module Owner
                    </Link> */}

 <Typography sx={{ color: "#696A6B", marginRight: "10px" }}>
          <Link
            href="/team-Members" sx={{ color: "#696A6B", textDecoration: "none", fontSize: 14, }}> Team Member </Link>/
        </Typography>{" "}
        Add Module Owner
  </Link>



                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography
                            variant="h3"
                            sx={{ fontSize: 24, fontWeight: 600, color: "#000", marginTop: "16px" }}
                        >
                            Add Module Owner
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ marginTop: "30px" }}>
                    <label
                        style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            color: "#8C8C8C",
                            marginBottom: "8px",

                        }}
                    >
                        INFORMATION
                    </label>
                </Box>
                <Formik
                    initialValues={initialValues}
                    enableReinitialize={true}

                    validationSchema={Yup.object({
                        first_name: Yup.string().required('First name is required'),
                        last_name: Yup.string().required('Last name is required'),
                        mobile_num: Yup.string().required('Mobile number is required'),
                        company_email_id: Yup.string().email('Invalid email format').required('Email ID is required'),
                        // team_id: Yup.string().required('Team is required'),
                        module_id: Yup.array()
                            .of(Yup.string().required('Module ID is required'))
                            .min(1, 'Please select at least one Module Ownership')
                            .required('Module Ownership is required'),

                        module_owner_email: Yup.string().required('Login ID is required'),
                        login_password: Yup.string().when('module_owner_email', {
                            is: (val: string) => val !== mainemaill,
                            then: (schema) => schema.required('Password is required'),
                            otherwise: (schema) => schema,
                        }),
                    })}
                    onSubmit={handleSubmit} // Using the handleSubmit function to send data to the API
                    
                >


                    {({ errors, touched, isValid, dirty, values ,submitForm,setFieldValue }) => (
                        <Form>
                            <Box mt={3} sx={{ display: "flex", gap: 4, flexWrap: "wrap", width: "800px" }}>
                                <FormControl>
                                    <label
                                        style={{
                                            fontSize: "16px",
                                            fontWeight: "500",
                                            color: "#282829",
                                            marginBottom: "8px",
                                        }}
                                    >
                                        First Name*
                                    </label>

                                    <Field
                                        name="first_name"
                                        placeholder="First Name"
                                        style={{
                                            minWidth: "352px",
                                            borderRadius: "10px",
                                            height: "52px",
                                            border: "1px solid #E7E8E9",
                                            padding: "14px 12px",
                                            color: "#7D7E7F",
                                            fontSize: "16px",
                                            fontWeight: "500",
                                        }}
                                    />

                                    {errors.first_name && touched.first_name && (
                                        <div style={{ color: 'red', fontSize: "14px", fontWeight: "400", marginTop: "4px" }}>
                                            {errors.first_name}
                                        </div>
                                    )}
                                </FormControl>

                                <FormControl>
                                    <label
                                        style={{
                                            fontSize: "16px",
                                            fontWeight: "500",
                                            color: "#282829",
                                            marginBottom: "8px",
                                        }}
                                    >
                                        Last Name*
                                    </label>

                                    <Field
                                        name="last_name"
                                        placeholder="Last Name"
                                        style={{
                                            minWidth: "352px",
                                            borderRadius: "10px",
                                            height: "52px",
                                            border: "1px solid #E7E8E9",
                                            padding: "14px 12px",
                                            color: "#7D7E7F",
                                            fontSize: "16px",
                                            fontWeight: "500",
                                        }}
                                    />

                                    {errors.last_name && touched.last_name && (
                                        <div style={{ color: 'red', fontSize: "14px", fontWeight: "400", marginTop: "4px" }}>
                                            {errors.last_name}
                                        </div>
                                    )}
                                </FormControl>
                                <FormControl>
                                    <label
                                        style={{
                                            fontSize: "16px",
                                            fontWeight: "500",
                                            color: "#282829",
                                            marginBottom: "8px",
                                        }}
                                    >
                                        Mobile Number*
                                    </label>

                                    <Field
                                        name="mobile_num"
                                        placeholder="eg. 7666782990"
                                        style={{
                                            minWidth: "352px",
                                            borderRadius: "10px",
                                            height: "52px",
                                            border: "1px solid #E7E8E9",
                                            padding: "14px 12px",
                                            color: "#7D7E7F",
                                            fontSize: "16px",
                                            fontWeight: "500",
                                        }}
                                    />

                                    {errors.mobile_num && touched.mobile_num && (
                                        <div style={{ color: 'red', fontSize: "14px", fontWeight: "400", marginTop: "4px" }}>
                                            {errors.mobile_num}
                                        </div>
                                    )}
                                </FormControl>

                                <FormControl>
                                    <label
                                        style={{
                                            fontSize: "16px",
                                            fontWeight: "500",
                                            color: "#282829",
                                            marginBottom: "8px",
                                        }}
                                    >
                                        Company Email ID*
                                    </label>

                                    <Field
                                        name="company_email_id"
                                        placeholder="eg. john.doe@company.com"
                                        style={{
                                            minWidth: "352px",
                                            borderRadius: "10px",
                                            height: "52px",
                                            border: "1px solid #E7E8E9",
                                            padding: "14px 12px",
                                            color: "#7D7E7F",
                                            fontSize: "16px",
                                            fontWeight: "500",
                                        }}
                                    />

                                    {errors.company_email_id && touched.company_email_id && (
                                        <div style={{ color: 'red', fontSize: "14px", fontWeight: "400", marginTop: "4px" }}>
                                            {errors.company_email_id}
                                        </div>
                                    )}
                                </FormControl>
                                <FormControl sx={{ width: "352px" }}>
                                    <label
                                        style={{
                                            fontSize: "16px",
                                            fontWeight: "500",
                                            color: "#282829",
                                            marginBottom: "8px",
                                        }}
                                    >
                                        Team*
                                    </label>
                                    <Field name="team_id">
                                        {({ field, form }: any) => {
                                            const showError = form.submitCount > 0 && (!field.value || field.value.length === 0);

                                            return (
                                                <FormControl sx={{ width: "352px" }}>


                                                    <Select
                                                        multiple
                                                        displayEmpty
                                                        id="team"
                                                        value={Array.isArray(field.value) ? field.value : []}
                                                        onChange={(event) => form.setFieldValue("team_id", event.target.value)}
                                                        onBlur={() => form.setFieldTouched("team_id", true)}
                                                        inputProps={{ "aria-label": "Select Team Access" }}
                                                        IconComponent={LineArrow}
                                                        renderValue={(selected: any) => {
                                                            if (selected.length === 0) {
                                                                return (
                                                                    <em style={{ color: "#A0A0A0", fontStyle: "normal" }}>
                                                                        Select Team Access
                                                                    </em>
                                                                );
                                                            }
                                                            return team
                                                                .filter((mod: any) => selected.includes(mod.id))
                                                                .map((mod: any) => mod.team_name)
                                                                .join(", ");
                                                        }}
                                                        sx={{
                                                            width: "100%",
                                                            borderRadius: "12px",
                                                            backgroundColor: "#fff",
                                                            fontSize: "16px",
                                                            fontWeight: "500",
                                                            color: "#000",
                                                            height: "52px",
                                                            "& .MuiSelect-select": {
                                                                padding: "14px 12px",
                                                            },
                                                            "& .MuiOutlinedInput-notchedOutline": {
                                                              borderColor: "#E7E8E9",
                                                          },
                                                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                              borderColor: "#E7E8E9",
                                                          },
                                                          "&:hover .MuiOutlinedInput-notchedOutline": {
                                                              borderColor: "#E7E8E9",
                                                          },
                                                            "& svg": {
                                                                top: "calc(50% - 4px)",
                                                                right: "12px",
                                                                position: "absolute",
                                                                pointerEvents: "none",
                                                            },
                                                            border: showError ? '1px solid red' : undefined,
                                                        }}
                                                    >
                                                        <MenuItem disabled value="">
                                                            <em style={{ color: "#A0A0A0" }}>Select Module Access</em>
                                                        </MenuItem>
                                                        {team.map((mod: any) => (
                                                            <MenuItem key={mod.id} value={mod.id}>
                                                                <Checkbox checked={field.value?.includes(mod.id)} />
                                                                {mod.team_name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>

                                                    {showError && (
                                                        <div
                                                            style={{
                                                                color: "red",
                                                                fontSize: "14px",
                                                                fontWeight: "400",
                                                                marginTop: "4px",
                                                            }}
                                                        >
                                                            Please select at least one Team Access
                                                        </div>
                                                    )}
                                                </FormControl>
                                            );
                                        }}
                                    </Field>

                                    {errors.team_id && touched.team_id && (
                                        <div style={{ color: 'red', fontSize: "14px", fontWeight: "400", marginTop: "4px" }}>
                                            {errors.team_id}
                                        </div>
                                    )}
                                </FormControl>
                                <FormControl sx={{ width: "352px" }}>

                                    <Field name="module_id">
                                        {({ field, form }: any) => {
                                            const showError = form.submitCount > 0 && (!field.value || field.value.length === 0);

                                            return (
                                                <FormControl sx={{ width: "352px" }}>
                                                    <label
                                                        style={{
                                                            fontSize: "16px",
                                                            fontWeight: "500",
                                                            color: "#282829",
                                                            marginBottom: "8px",
                                                        }}
                                                    >
                                                        Module Ownership*
                                                    </label>

                                                    <Select
                                                        multiple
                                                        displayEmpty
                                                        id="module"
                                                        // value={field.value || []}
                                                        // onChange={(event) => form.setFieldValue("module_id", event.target.value)}
                                                        value={field.value?.filter((id: any) => {
    return modules.find((mod: any) => mod.id === id && mod.status !== "not exist");
  }) || []}

  onChange={(event) => {
  const selectedValues = event.target.value;

  // Filter out modules that are assigned
    const filteredValues = selectedValues.filter((id: any) => {
      const mod = modules.find((mod: any) => mod.id === id);
      return mod;
    });

  // Update Formik field value
  form.setFieldValue("module_id", filteredValues);

  // Create a comma-separated string of selected module names
  const selectedNames = modules
    .filter((mod: any) => filteredValues.includes(mod.id))
    .map((mod: any) => mod.module_name)
    .join(", ");

  // Update the useState
  setSelectedModuleNames(selectedNames);
}}



                                                        onBlur={() => form.setFieldTouched("module_id", true)}
                                                        inputProps={{ "aria-label": "Select Module Access" }}
                                                        IconComponent={LineArrow}
                                                        renderValue={(selected: any) => {
                                                            if (selected.length === 0) {
                                                                return (
                                                                    <em style={{ color: "#A0A0A0", fontStyle:"normal" }}>
                                                                        Select Module Ownership
                                                                    </em>
                                                                );
                                                            }
                                                            return modules
                                                                .filter((mod: any) => selected.includes(mod.id))
                                                                .map((mod: any) => mod.module_name)
                                                                .join(", ");
                                                        }}
                                                        sx={{
                                                            width: "100%",
                                                            borderRadius: "12px",
                                                            backgroundColor: "#fff",
                                                            fontSize: "16px",
                                                            fontWeight: "500",
                                                            color: "#000",
                                                            height: "52px",
                                                            "& .MuiSelect-select": {
                                                                padding: "14px 12px",
                                                            },
                                                            "& .MuiOutlinedInput-notchedOutline": {
                                                              borderColor: "#E7E8E9",
                                                          },
                                                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                              borderColor: "#E7E8E9",
                                                          },
                                                          "&:hover .MuiOutlinedInput-notchedOutline": {
                                                              borderColor: "#E7E8E9",
                                                          },
                                                            "& svg": {
                                                                top: "calc(50% - 4px)",
                                                                right: "12px",
                                                                position: "absolute",
                                                                pointerEvents: "none",
                                                            },
                                                            border: showError ? '1px solid red' : undefined,
                                                        }}
                                                    >
                                                        <MenuItem disabled value="">
                                                            <em style={{ color: "#A0A0A0", fontStyle: "normal" }}>Select Module Ownership</em>
                                                        </MenuItem>
{modules.map((mod: any) => (
  <MenuItem key={mod.id} value={mod.id}>

      <Checkbox checked={field.value?.includes(mod.id)} />
   
    {mod.module_name}
  </MenuItem>
))}



                                                    </Select>

                                                    {/* {showError && (
                                                        <div
                                                            style={{
                                                                color: "red",
                                                                fontSize: "14px",
                                                                fontWeight: "400",
                                                                marginTop: "4px",
                                                            }}
                                                        >
                                                            Please select at least one Module Ownership
                                                        </div>
                                                    )} */}
                                                </FormControl>
                                            );
                                        }}
                                    </Field>


                                    {errors.module_id && touched.module_id && (
                                        <div style={{ color: 'red', fontSize: "14px", fontWeight: "400", marginTop: "4px" }}>
                                            {errors.module_id}
                                        </div>
                                    )}
                                </FormControl>
                            </Box>
                            <Typography
                                sx={{
                                    fontSize: "16px",
                                    fontWeight: 500,
                                    color: "#8C8C8C",
                                    marginTop: "32px",
                                    marginBottom: "16px",
                                    textTransform: "uppercase",
                                }}
                            >
                                Login & Password
                            </Typography>

                            {/* Login ID and Password Fields */}
                            <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap", width: "800px" }}>
                              <FormControl>
                                    <label
                                        style={{
                                            fontSize: "16px",
                                            fontWeight: "500",
                                            color: "#282829",
                                            marginBottom: "8px",
                                        }}
                                    >
                                        Provide Login ID*
                                    </label>

                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            border: "1px solid #E7E8E9",
                                            borderRadius: "10px",
                                            height: "52px",
                                            minWidth: "352px",
                                            paddingLeft: "12px",
                                            paddingRight: "12px",
                                            background: "#fff"

                                        }}
                                    >
                                        <Field
                                            name="module_owner_email"
                                            placeholder="Provide Login ID"
                                            style={{
                                                border: "none",
                                                outline: "none",
                                                flexGrow: 1,
                                                color: "#7D7E7F",
                                                fontSize: "16px",
                                                fontWeight: "500",
                                            }}
                                        />
                                        <Typography
                                            sx={{
                                                fontSize: "14px",
                                                fontWeight: 500,
                                                color: "#C8102E",
                                                whiteSpace: "nowrap",
                                                cursor: "pointer",
                                            }}
                                         onClick={() => {
        values.company_email_id && setFieldValue("module_owner_email", values.company_email_id);
      }}
                                        >
                                            Set as company email
                                        </Typography>
                                    </Box>
                                    {errors.module_owner_email && touched.module_owner_email && (
                                        <div style={{ color: "red", fontSize: "14px", marginTop: "4px" }}>{errors.module_owner_email}</div>
                                    )}
                                </FormControl>


                              <FormControl>
  <label
    style={{
      fontSize: "16px",
      fontWeight: "500",
      color: "#282829",
      marginBottom: "8px",
    }}
  >
    Provide Password*
  </label>

  <Field name="login_password">
    {({ field, form }: any) => {
      return (
        <Select
          value={field.value || ""}
          onChange={(event) => {
            const selected = event.target.value;
            let generatedPassword = "";

            if (selected === "Default") {
              generatedPassword = generatePassword(8);
            } else if (selected === "Temporary") {
              generatedPassword = generatePassword(12);
            }

            form.setFieldValue("login_password", generatedPassword);
          }}
          displayEmpty
          IconComponent={LineArrow}
          sx={{
            minWidth: "352px",
            height: "52px",
            borderRadius: "10px",
            backgroundColor: "#fff",
            "& .MuiSelect-select": {
              padding: "14px 12px",
              fontSize: "20px",
              fontWeight: "700",
              color: "#000",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E7E8E9",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E7E8E9",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E7E8E9",
            },
            "& svg": {
              top: "calc(50% - 4px)",
              right: "12px",
              position: "absolute",
              pointerEvents: "none",
            },
          }}
          renderValue={(value) => {
            if (!value) {
              return (
                <span
                  style={{
                    color: "#A0A0A0",
                    fontSize: "14px",
                    fontWeight: "400",
                    position: "relative",
                    top: "0px",
                  }}
                >
                  Provide password
                </span>
              );
            }

            const isDefault = value.length === 8;
            const isTemporary = value.length === 12;

            return (
              <span style={{ position: "relative", top: "7px" }}>
                {isDefault
                  ? "********"
                  : isTemporary
                  ? "************"
                  : "********"}
              </span>
            );
          }}
        >
          <MenuItem disabled value="">
            <em style={{ color: "#A0A0A0" }}>Provide password</em>
          </MenuItem>
          <MenuItem value="Default">Default</MenuItem>
          <MenuItem value="Temporary">Temporary</MenuItem>
        </Select>
      );
    }}
  </Field>

  {errors.login_password && touched.login_password && (
    <div style={{ color: "red", fontSize: "14px", marginTop: "4px" }}>
      {errors.login_password}
    </div>
  )}
</FormControl>

                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    backgroundColor: '#FFF8E1',
                                    padding: '12px 16px',
                                    borderRadius: '8px',
                                    marginTop: '24px',
                                    width: 'fit-content',
                                    maxWidth: '800px',
                                }}
                            >
                                <Box
                                    component="span"
                                    sx={{
                                        width: 20,
                                        height: 20,
                                        borderRadius: '50%',
                                        backgroundColor: '#FFC107',
                                        color: '#fff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: 14,
                                        fontWeight: 600,
                                        marginRight: '12px',
                                    }}
                                >
                                    i
                                </Box> 
                                 <Typography
                                    sx={{
                                        fontSize: '14px',
                                        fontWeight: 500,
                                        color: '#4A4A4A',
                                    }}
                                >
                                    Note: Clicking “Submit” will trigger an email to the member along with their credentials
                                </Typography> 
                            </Box>

                            <Box sx={{ width: "105%", marginLeft: "-32px", background: "#fff", borderTop: "1px solid #cfcfcf", marginTop: "20px", marginBottom: "10px" }}>
                                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                    <Button sx={{ fontSize: "14px", fontWeight: "500", color: "#C8172F", textTransform: "capitalize", padding: "0", marginLeft: "50px" }} onClick={() => navigate('/team-Members')}>
                                        <img style={{ marginRight: "8px" }} src={arrowleft} alt="arrowleft" />Back
                                    </Button>
                                    <Box>

                                        <Button
                                           
                                              onClick={() => setConfirmOpen(true)}
                                            disabled={!(isValid && dirty)}
                                            style={{
                                                marginTop: "20px",
                                                backgroundColor: isValid && dirty ? "#C8102E" : "#ccc",
                                                color: "#fff",
                                                border: "none",
                                                padding: "10px 20px",
                                                borderRadius: "8px",
                                                fontWeight: "600",
                                                cursor: isValid && dirty ? "pointer" : "not-allowed",
                                                marginRight: "50px"
                                            }}
                                        >
                                            Submit
                                        </Button>

                                          
                                    </Box>
                                     <ConfirmPopup
                                        handleYes={() => handleSubmit(values)}
                                        statusdata={statusdata}
                                        setstatusdata={setstatusdata}
                                        open={confirmOpen}
                                        onClose={handleCloseConfirm}
                                        onConfirm={handleConfirmSubmit}
                                        chekmodulw={1}
                                        moduleOwner={values.first_name} editteammemver={0}      />
                                </Box>
                            </Box>

                        </Form>
                    )}
                </Formik>
            </Box>

        </Box>
    );
};

export default ModuleOwnerForm;